








































import Vue from 'vue';
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';
import DialogTestLogic from './DialogTestLogic.vue';

type ActionFunc = (arg: any) => void;
interface LogicControlForm {
    name?: string | null;
    category?: any;
    description?: string | null;
    logic?: any[];
}

@Component({
    computed: {
        ...mapGetters('logic-control-category', { getCategory: 'get' }),
        ...mapState('logic-control-category', { isFindPedingCategory: 'isFindPending' })
    },
    methods: {
        ...mapActions('logic-control', { addLogic: 'create' }),
        ...mapActions('logic-control-category', { getCategoryById: 'get' }),
        ...mapMutations('bh-flow', { hideProperties: 'hide' })
    },
    components: {
        DialogTestLogic
    }
})
export default class DialogAddLogic extends Vue {
    @Prop({ default() { return {}; } })
    item: any;

    dialog = false;
    loading = false;
    logicForm: LogicControlForm = {};

    addLogic!: ActionFunc;
    hideProperties: any;
    getCategory: any;
    getCategoryById: any;

    @Watch('dialog')
    async ResetForm(nv: boolean) {
        if(nv) {
            this.hideProperties();
            this.logicForm = {
                name: this.item.name,
                category: this.currentCategory,
                description: this.item.description,
                logic: JSON.parse(this.item.logic)
            };
        }
    }

    @Watch('isFindPedingCategory')
    DisplayCurrentCategory(nv: boolean) {
        if(nv === false) {
            this.logicForm.category = this.currentCategory;
        }
    }

    get currentCategory() {
        return this.getCategory(this.item.category_id);
    }

    get logicAlias() {
        return (this.logicForm.name || '').toLowerCase().replace(/\W/g, '-').replace(/-+/g, '-');
    }

    public async saveLogic() {
        this.item.name = this.logicForm.name;
        this.item.category_id = this.logicForm.category.id;
        this.item.alias = this.logicAlias;
        this.item.description = this.logicForm.description;
        this.item.logic = JSON.stringify(this.logicForm.logic);
        await this.item.patch();
    }

    public async UpdateLogicData() {
        try {
            this.loading = true;
            this.saveLogic();
            this.hideProperties();
            this.$emit('success');
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }
}
